import { InvoiceStatus } from "@api/core/logistics/invoices/invoices.model";

export type Invoice = {
  name: string;
  logistics_provider: string;
  brand?: string;
  warehouse: string;
  logistics_charges: number;
  favorable_errors_count?: number;
  favorable_errors_dollars?: number;
  unfavorable_errors_count?: number;
  unfavorable_errors_dollars?: number;
  unfavorable_errors_rejected_count?: number;
  unfavorable_errors_rejected_dollars?: number;
  credit_requested_errors_count?: number;
  credit_requested_errors_dollars?: number;
  creditable_errors_count?: number;
  creditable_errors_dollars?: number;
  start_date: string;
  end_date: string;
  status: InvoiceStatus;
  types: string[];
  // We now get more specific info. Summary-only vs reconciled
  summary_types?: string[];
  summary_total_charges?: number;
  reconciled_types?: string[];
  reconciled_total_charges?: number;
};

export enum InvoiceTableHeader {
  INVOICE = "Invoice",
  STATUS = "Status",
  PERIOD = "Period",
  LOGISTICS_PROVIDER = "Vendor",
  CHARGES = "Invoiced",
  ERRORS = "Creditable",
  TYPE = "Type",
  WAREHOUSE = "Warehouse",
}

export type InvoiceSortCriteria = {
  key: InvoiceTableHeader;
  order: "ascending" | "descending";
};

export type InvoiceHightlightTotals = {
  savingsDollars: number;
  savingsCount: number;
  requestedDollars: number;
  requestedCount: number;
  recoverableDollars: number;
  totalCount: number;
  totalCountOutstanding: number;
};

export enum RollupInvoiceTableHeader {
  INVOICE = "Invoice",
  STATUS = "Status",
  SERVICES = "Services",
  EXPECTED = "Expected",
  INVOICED = "Invoiced",
  ERRORS = "Creditable",
};

export type RollupInvoiceSortCriteria = {
  key: RollupInvoiceTableHeader;
  order: "ascending" | "descending";
}
